import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Button,
  Disclosure,
  DisclosureGroup,
  DisclosurePanel,
} from 'react-aria-components';
import styles from './styles.module.css';
import cx from 'classnames';
import type { MenuItem } from './menu';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

type MobileDropdownMenuItemProps = {
  title: string;
  id: string;
  items: MenuItem[];
  open?: () => void;
  close?: () => void;
  setActiveMenuItem?: React.Dispatch<React.SetStateAction<MenuItem>>;
  disableTabbing?: boolean;
  titleasp?: boolean;
  parent_title?: string;
};

type Key = string | number;

export default function MenuMobile({
  title,
  id,
  items,
  disableTabbing,
  titleasp,
  parent_title = '',
}: MobileDropdownMenuItemProps) {
  let tabProps = {};
  if (disableTabbing)
    tabProps = { tabIndex: -1, 'aria-disabled': true, disabled: true };

  const location = useLocation();

  const [expandedKeys, setExpandedKeys] = useState<Iterable<Key>>(new Set());

  // close panel when location changes
  useEffect(() => {
    setExpandedKeys(new Set()); // resets expanded disclosure panel
  }, [location.pathname]);

  const handleDisclosureChange = (keys: Iterable<Key>) => {
    setExpandedKeys(keys);
  };

  return (
    <DisclosureGroup
      className={cx('react-aria-DisclosureGroup', styles['disclosure-group'])}
      expandedKeys={expandedKeys}
      onExpandedChange={handleDisclosureChange}
    >
      <Disclosure
        id={id}
        className={cx('react-aria-Disclosure', styles['disclosure'])}
      >
        <Button
          slot="trigger"
          className={cx(
            'react-aria-Button',
            styles['submenu-sheet-nav-list-button'],
          )}
        >
          {titleasp ? (
            <>
              <p className={cx('h1', styles['ph1'])}>{parent_title}</p>
              <h1 className="sr-only">{title}</h1>
            </>
          ) : (
            <h1>{title}</h1>
          )}
          <svg
            viewBox="0 0 24 24"
            className={styles['submenu-sheet-nav-list-button-svg']}
            style={{ strokeWidth: 5, width: '1.25rem', height: '1.25rem' }}
          >
            <path d="m8.25 4.5 7.5 7.5-7.5 7.5" />
          </svg>
        </Button>
        <DisclosurePanel className={styles['disclosure-panel']}>
          <ul
            className={cx(
              styles['submenu-sheet-nav-list'],
              styles['no-list-styles'],
            )}
          >
            {items?.map((item: MenuItem) => {
              // TODO check type
              let props: any = {
                href: flattenToAppURL(item['@id']),
                className: cx(
                  styles['submenu-sheet-nav-list-button'],
                  styles['bold'],
                ),
              };
              return (
                <li
                  key={item['@id']}
                  id={item['@id']}
                  className={cx(
                    styles['submenu-sheet-nav-list-item'],
                    item.active && styles['active'],
                  )}
                  {...tabProps}
                >
                  <UniversalLink {...tabProps} {...props}>
                    {item.title}
                  </UniversalLink>
                </li>
              );
            })}
          </ul>
        </DisclosurePanel>
      </Disclosure>
    </DisclosureGroup>
  );
}
